import type { WorkflowFailurePointsResponse } from '../types/catalog-operations.types';

/** Why a loaded failure-points answer can't be retried from. */
export type RetryBlocker =
  | { kind: 'history-unavailable'; reason: string | null }
  | { kind: 'no-failure-point' };

/**
 * Reads a failure-points response for "is there anything to retry from?".
 * `historyAvailable: false` (run past Temporal retention) and an empty list
 * both mean the retry dialog would have nothing to confirm, so callers keep
 * Retry disabled and explain why instead of opening an empty dialog.
 * Returns `null` while unloaded or when a point exists.
 */
export function getRetryBlocker(
  failurePoints: WorkflowFailurePointsResponse | undefined,
): RetryBlocker | null {
  if (!failurePoints) return null;
  if (failurePoints.historyAvailable === false) {
    return { kind: 'history-unavailable', reason: failurePoints.reason ?? null };
  }
  if (failurePoints.failurePoints.length === 0) return { kind: 'no-failure-point' };
  return null;
}
